import { Component, OnInit ,Input, Output, EventEmitter,AfterViewInit} from '@angular/core';
import { Router, ActivatedRoute ,Params} from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment'; 
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { CustomServiceService } from '../../service/custom-service.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit, AfterViewInit {
photo: any;

  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute,private encDec: EncryptDecryptService,private route: Router,    private router: ActivatedRoute,private httpservice: CustomServiceService) { }
  language:any =sessionStorage.getItem('locale');//dynamic
  query_menu:any;
  param_menualias:any;
  mainmenuid:any;
  content_page_parames:any;
  sortmenu:any;
  Categoryid:any;
   imageUrl = environment.serviceURL + 'storage/app/uploads/';
  // imageUrl = environment.tempUrl;
  backendUrl = environment.serviceURL;
  start:number=0;
  limit:number=10;
  currentPage:number = 1;
  totalRecords:number=0;
  galleryid:any
  photoCatId: any;
  datetime:any = this.httpservice.currentDateTime();

  ngOnInit(): void {
    this.router.params.subscribe((params: Params) => {
    
      this.photoCatId = this.encDec.decText( params['id']);
      this.getphotoGallery();
      
    });
    this.query_menu = this.routerparam.snapshot.queryParamMap.get('menu');
    this.param_menualias = this.routerparam.snapshot.paramMap.get('menualias');
    this.mainmenuid = this.routerparam.snapshot.paramMap.get('mainmenuid');
    this.Categoryid = this.routerparam.snapshot.paramMap.get('Categoryid');
      
   this.content_page_parames = {
     'query_menu':this.query_menu,'param_menualias':this.param_menualias,'mainmenuid':this.mainmenuid,menutype:'primary','innermenualias':'','innermenuaid':''
   }
   if(this.routerparam.snapshot.queryParamMap.get('menu')){
     this.sortmenu = this.query_menu.split('+');
   } else{
     this.sortmenu =['',''];
   }
   this.start=(this.currentPage - 1)*this.limit;
    // FOR PHOTO GALLERY AND VIDEO GALLERY - STARTS
     
    this.getAllPhotos();
    this.getGalleryCat();
     this.getAllImages('',this.start,this.limit,this.currentPage);
  }

  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }
  content_apiresponse:any;
  gallery :any;
  galleryCatName:any;
  getAllPhotos(){

    let params = [{
      "secSlNo":1,
        "offSet":0,
        "noOfRecords":'',
        "orderBy":[{"columnName":"intId","type":"DESC"}],
        "condition":[
             {"columnName":"UPLOAD_TYPE","operator":"=","value":1,"joinoperator":"and"},
            {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
            {"columnName":"tinPublishStatus","operator":"=","value":1,"joinoperator":"and"}
            ],
        "viewParameters":""
    }];
    this.fciwebservice.getPhotoGallery(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.gallery = response.result.sec_1;
          } 
      }
    });

  }
  galleryCatNm:any='';
  getGalleryCat(){
 
    let params = [{
      "secSlNo":1,
        "offSet":0,
        "noOfRecords":'',
        "orderBy":[{"columnName":"intId","type":"ASC"}],
        "condition":[
            {"columnName":"VCHMEDIATYPE","operator":"=","value":1,"joinoperator":"and"},
            {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
            {"columnName":"tinPublishStatus","operator":"=","value":1,"joinoperator":"and"},
            {"columnName":"intId","operator":"=","value":this.photoCatId,"joinoperator":"and"}
            ],
        "viewParameters":""
    }];
    this.fciwebservice.getGalleryCat(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
         case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            if(response.result.sec_1.length > 0){
              this.galleryCatNm = this.language=="English"? response.result.sec_1[0]['category'] : response.result.sec_1[0]['categoryInHindi'];
            } 
          }
      }
    });

  }

   getAllImages(data:any,start:number,limit:number,currentPage:number){
    var query;
    if(data!==''){
      query = [
        {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
        {"columnName":"tinPublishStatus","operator":"=","value":1,"joinoperator":"and"},
        {"columnName":"VCHCATEGORY","operator":"=","value":data.value,"joinoperator":"and"}
        ];
    } else{
      query = [
        {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
        {"columnName":"tinPublishStatus","operator":"=","value":1,"joinoperator":"and"},
        {"columnName":"UPLOAD_TYPE","operator":"=","value":1,"joinoperator":"and"},
        ];
    }
    let cateid = this.Categoryid;
    let params = [{
      "secSlNo":1,
        "offSet":0,
        "noOfRecords":'',
        "orderBy":[{"columnName":"intId","type":"ASC"}],
        "condition":query,
        "viewParameters":""
    }];
    this.fciwebservice.getPhotoGallery(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.galleryCatName = response.result.sec_1;
            if(response.result.sec_1.length > 0){
              this.totalRecords = response.result.sec_1[0].noOfRec;
              
            } else {
              this.totalRecords = 0;
            }
          }
      }
    });


 }
 
 pageChanged(page: any) {
  this.currentPage=page
  this.start=(this.currentPage - 1)*this.limit;
  this.getAllImages('',this.start,this.limit,this.currentPage);
}
catwiseGallery:any =[];
catepid:any;
categoryName:any;
getphotoGallery()  
{
  
    var catepid = this.photoCatId;
    var query;
    query = [
      {"columnName":"bitDeletedFlag","operator":"=","value":0,"joinoperator":"and"},
      {"columnName":"tinPublishStatus","operator":"=","value":1,"joinoperator":"and"},
      {"columnName":"VCHCATEGORY","operator":"=","value":catepid,"joinoperator":"and"},
      {"columnName":"UPLOAD_TYPE","operator":"=","value":1,"joinoperator":"and"},
      {"columnName":"ARCHIVE_DATE","operator":">","value":this.datetime.date,"joinoperator":"and"},
      
      ];
    let params = [{
      "secSlNo":1,
        "offSet":0,
        "noOfRecords":'',
        "orderBy":[{"columnName":"intId","type":"ASC"}],
        "condition":query,
        "viewParameters":""
    }];
    this.fciwebservice.getPhotoGallery(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.catwiseGallery = response.result.sec_1;
          //  console.log(this.catwiseGallery);
            this.categoryName= catepid;
            setTimeout(()=>{
              $('#gallery-container').lightGallery();
            },1000)
          }
      }
    });
}
htmlTag(data:any){
  return this.encDec.decodeHtml(data);
}

encode(data:any){
  return btoa(data);
}


getTitle(id:any) {
  for (let i = 0; i < this.catwiseGallery.length; i++) {
    const jsonOptTxtDetails = JSON.parse(this.catwiseGallery[i].jsonOptTxtDetails);
    if (jsonOptTxtDetails && jsonOptTxtDetails.VCHCATEGORY && id > 0) {
      return jsonOptTxtDetails.VCHCATEGORY;
    }
  }
  
}

viewDetails(id: any, pageName: any){
  let encSchemeStr = this.encDec.encText(id.toString());
  this.route.navigate(['./'+ pageName +'/', encSchemeStr]);
}





htmldecode(str: any){
  return this.encDec.decodeHtml(str);
}

FileCheck(item:any):boolean{
  let check:boolean =false;
  if(item==null && item==undefined){
     check = false;
     return check;
  }
  if(item.uploadImage!="" && item.uploadImage!=undefined){
    if(item.uploadImage_details!=undefined){
      check = true;
    }
  }
  return check;
}



}

